import React, { useState, useEffect } from "react";
import apinode from "../../services/apinode";

const CatalogNotification = () => {
  const [catalogData, setCatalogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedSeller, setExpandedSeller] = useState(null);

  useEffect(() => {
    const fetchCatalog = async () => {
      try {
        setLoading(true);
        const res = await apinode.get(
          `/anuncios/busca-catalago/${localStorage.idconta}`
        );
        if (res.data && res.data.length > 0) {
          setCatalogData(res.data);
        }
      } catch (err) {
        console.error("Erro ao buscar catálogo:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCatalog();
  }, []);

  if (loading) return <p style={{ padding: "20px" }}>⏳ Carregando...</p>;
  if (!catalogData || catalogData.length === 0)
    return <p style={{ padding: "20px" }}>Nenhum produto encontrado.</p>;

  // Pega menor data de moderação de cada seller
  const getNextModerationDate = (anuncios) => {
    const dates = anuncios
      .map((a) => a.catalog_forewarning?.moderation_date)
      .filter(Boolean)
      .map((d) => new Date(d));
    if (dates.length === 0) return null;
    return new Date(Math.min(...dates));
  };

  return (
    <div className="catalog-wrapper">
      <div className="catalog-card">
        <div className="catalog-header">
          <h3>📦 Anúncios de Pré-Catálogo</h3>
        </div>

        {/* Dashboard resumido */}
        <div className="cards-row">
          {catalogData.map((loja) => {
            const nextDate = getNextModerationDate(
              loja.anuncios_detalhes || []
            );
            const isUrgent =
              nextDate &&
              (nextDate.toDateString() === new Date().toDateString() ||
                nextDate <=
                  new Date(new Date().setDate(new Date().getDate() + 1)));

            return (
              <div
                key={loja.id_loja}
                className={`mini-card ${isUrgent ? "urgent" : ""}`}
                onClick={() =>
                  setExpandedSeller(
                    expandedSeller === loja.id_loja ? null : loja.id_loja
                  )
                }
              >
                <h5>{loja.apelido || `Loja ${loja.id_loja}`}</h5>
                <p>
                  <strong>{loja.total}</strong> anúncios
                </p>
                {nextDate ? (
                  <p className="next-date">
                    {isUrgent ? "⚠ Urgente: " : "Próxima revisão: "}
                    {nextDate.toLocaleDateString("pt-BR", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                ) : (
                  <p className="next-date">Sem data de moderação</p>
                )}
                <span className="expand-hint">
                  {expandedSeller === loja.id_loja
                    ? "▲ Fechar"
                    : "▼ Ver mais"}
                </span>
              </div>
            );
          })}
        </div>

        {/* Detalhes expandido */}
        {expandedSeller && (
          <div className="expanded-block">
            {catalogData
              .filter((loja) => loja.id_loja === expandedSeller)
              .map((loja) => (
                <div key={loja.id_loja}>
                  <h4>
                    Conta: {loja.apelido || loja.id_loja}{" "}
                    <span className="badge-count">{loja.total} anúncios</span>
                  </h4>

                  <div className="products-list">
                    {loja.anuncios_detalhes?.map((item) => (
                      <div key={item.id} className="product-row">
                        <div className="product-info">
                          {item.thumbnail && (
                            <img src={item.thumbnail} alt={item.title} />
                          )}
                          <div>
                            <h6>{item.title}</h6>
                            <p>MLB {item.codigomk}</p>
                          </div>
                        </div>

                        <div className="product-price">
                          <strong>
                            R$ {item.price?.toFixed(2) || "0,00"}
                          </strong>
                        </div>

                        <div className="product-status">
                          {item.catalog_forewarning?.moderation_date ? (
                            <p>
                              Será pausado em{" "}
                              {new Date(
                                item.catalog_forewarning.moderation_date
                              ).toLocaleDateString("pt-BR", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              })}
                            </p>
                          ) : (
                            <p>Sem data de moderação</p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* Estilos */}
      <style>{`
        .catalog-wrapper {
          padding: 16px;
        }

        .catalog-card {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 10px;
          padding: 20px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        }

        .catalog-header h3 {
          margin: 0 0 16px;
          font-size: 18px;
          font-weight: 700;
          color: #333;
        }

        .cards-row {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        }

        .mini-card {
          flex: 1 1 240px; /* ocupa espaço disponível */
          max-width: 300px;
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 12px;
          cursor: pointer;
          transition: all 0.2s;
          background: #fff;
        }

        .mini-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        }

        .mini-card.urgent {
          border: 1px solid #dc3545;
          background: #fff5f5;
        }

        .mini-card h5 {
          margin: 0 0 8px;
          font-size: 15px;
          font-weight: 600;
        }

        .mini-card p {
          margin: 4px 0;
          font-size: 13px;
          color: #444;
        }

        .next-date {
          font-size: 12px;
          color: #666;
        }

        .expand-hint {
          display: block;
          margin-top: 8px;
          font-size: 12px;
          color: #3483FA;
          font-weight: bold;
        }

        .expanded-block {
          margin-top: 24px;
          border-top: 2px solid #3483FA;
          padding-top: 16px;
        }

        .products-list .product-row {
          display: grid;
          grid-template-columns: 2fr 1fr 2fr;
          align-items: center;
          padding: 12px 16px;
          border-bottom: 1px solid #eee;
        }

        .product-info {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .product-info img {
          width: 50px;
          height: 50px;
          border-radius: 6px;
          border: 1px solid #ddd;
        }

        .product-info h6 {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
        }

        .product-info p {
          margin: 0;
          font-size: 12px;
          color: #888;
        }

        .product-price strong {
          font-size: 14px;
          color: #28a745;
        }

        .product-status p {
          font-size: 12px;
          color: #856404;
          margin: 0;
        }

        .badge-count {
          background: #3483FA;
          color: #fff;
          padding: 3px 8px;
          border-radius: 12px;
          font-size: 12px;
          margin-left: 8px;
        }
      `}</style>
    </div>
  );
};

export default CatalogNotification;
